import { StyledImg } from "../../../styled";
import ImageLoader from "./Icons";

const Icon = ({ name, width, height, ...props }) => {
  const Image = ImageLoader[name];
  return (
    <StyledImg
      width={width || "32px"}
      height={height || "auto"}
      src={Image}
      alt={name}
      {...props}
    />
  );
};

export default Icon;
